import ApplicationController from '@app/javascript/controllers/application_controller'
import { useBusItem } from '@app/javascript/controllers/mixins/useBusItem.js'

export class Controller extends ApplicationController {
  static targets = ['formInput', 'navigationItem']
  static values = { defaultSelected: String }

  doConnect() {
    useBusItem(this, { addToBus: false })

    this.defaultSelectedItem = this.findDefaultNavItem()
  }

  findDefaultNavItem() {
    if (!this.defaultSelectedValue) return

    return this.navigationItemTargets.find((navItem) =>
      navItem.querySelector(`a[data-content-type="${this.defaultSelectedValue}"]`)
    )
  }

  navigationItemClicked(event) {
    event.preventDefault()

    this.recordSelectedContentTypeToFormInput(event.currentTarget)
    this.reloadContentTypeFilters(event.currentTarget)
  }

  recordSelectedContentTypeToFormInput(navItem) {
    this.formInputTarget.value = navItem.getAttribute('data-content-type')
  }

  reloadContentTypeFilters(selectedNavItem) {
    const filters = selectedNavItem && JSON.parse(selectedNavItem.getAttribute('data-content-type-filters'))

    this.getBusItem('search-v2--content-type-filters').reloadContentTypeFilters(filters)
  }

  formInputCleared() {
    this.clearAnySelections()
    this.selectDefaultItem()
    this.reloadContentTypeFilters()
  }

  clearAnySelections() {
    this.navigationItemTargets.forEach((navItem) => {
      navItem['shared--navigation-links--item'].unselectThisItem()
    })
  }

  selectDefaultItem() {
    if (!this.defaultSelectedItem) return

    this.defaultSelectedItem['shared--navigation-links--item'].selectThisItem()
    this.formInputTarget.value = this.defaultSelectedValue
  }
}
